import { RootState } from '../store';

export const isNavigationExpanded = (state: RootState): boolean => state.app?.isNavigationExpanded;
export const selectIsSearchBarOpen = (state: RootState): boolean => state.app?.isSearchBarOpen;
export const selectIsGeoLocationAllowed = (state: RootState): boolean | undefined => state.app?.isGeoLocationAllowed;
export const selectIsErrorDuringGeoCheck = (state: RootState): boolean => state?.app.isErrorDuringGeoCheck;
export const selectSelectedCategory = (state: RootState): string => state?.app.selectedCategory;
